import React, {useState, useEffect, useContext} from 'react';
import {Link} from 'react-router-dom';
import AuditContext from '../Utils/context.js';
import {useLocalStorage} from 'react-use';
import {
  Button,
  Col,
  Container,
  Row,
  Form,
  Breadcrumb,
  Card,
} from 'react-bootstrap';
import axios from 'axios';
import {
  CustomPaging,
  PagingState,
  SortingState,
  SearchState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableColumnResizing,
  SearchPanel,
  Toolbar,
} from '@devexpress/dx-react-grid-bootstrap4';
import { Loading } from 'components/Loading/loading';
import moment from 'moment';

const SORT_FIELD_MAP = {};

export default function Monitoring() {

  const {schedule} = useContext(AuditContext);
  const [auth] = useLocalStorage('authenticated');

  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizes] = useState([15,25,50]);
  const [columns] = useState([
    {name: 'ACTIONS', title: 'Action', getCellValue: row => {
      let variant = `primary`, label = `Open`;
      switch (row.ANSWER_ACTION_STATUS) {
        case 'COMPLETED':
          variant = `success`;
          label = moment(row.COMPLETED_AT, 'DD-MMM-YYYY').format(`DD MMM YYYY`);
          break;
        case `IN PROGRESS`:
          variant = `warning`;
          label =  'In Progress';
      }
      return (
        <Link to={`/admin/actions/${row.ANSWER_ACTION_ID}/edit`}>
          <Button variant={variant} size="sm">{label}</Button>
        </Link>
      );
    }},
    {name: 'ANSWER_ACTION_ID', title: 'ID'},
    {name: 'AUDITEE', title: 'AUDITEE', getCellValue: row => row?.answer?.form?.schedule?.auditee?.department?.DEPT_NAME ?? `n-a`},
    {name: 'INSTRUMENT', title: 'INSTRUMENT', getCellValue: row => row?.answer?.form?.schedule?.instrument?.INSTRUMENT_NAME ?? `n-a`},
    {name: 'CRITERIA', title: 'Criteria', getCellValue: row => row?.answer?.form?.criteria.CRITERIA_LABEL ?? `n-a`},
    {name: 'CAUSE_DESC', title: 'Finding', getCellValue: row => row?.answer.CAUSE_DESC ?? `n-a`},
    {name: 'TYPE', title: 'Type', getCellValue: row => row?.actionType.ACTION_TYPE_NAME ?? `n-a`},
    {name: 'DUE_DATE', title: 'Due Date', getCellValue: row => moment(row.DUE_DATE, 'DD-MMM-YYYY').format('DD MMM YYYY') ?? `n-a`},
    {name: 'PIC', title: `PIC`, getCellValue: row => row?.pics?.reduce((acc, cur, idx) => {
      if (idx === 0) return cur?.employee?.EMP_NAME;
      return acc + `, ` + cur?.employee?.EMP_NAME;
    }, '')},
  ]);

  const [defaultColumnWidths] = useState([
    { columnName: 'ANSWER_ACTION_ID', width: 60 },
    {columnName: 'AUDITEE', width: 180 },
    {columnName: 'INSTRUMENT', width: 180 },
    { columnName: 'CRITERIA', width: 200 },
    {columnName: 'CAUSE_DESC', width: 180 },
    {columnName: 'TYPE', width: 180 },
    {columnName: 'DUE_DATE', width: 180 },
    {columnName: 'PIC', width: 180 },
    {columnName: 'ACTIONS', width: 100 }
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [sorting, setSorting] = useState([{ columnName: 'ANSWER_ACTION_ID', direction: 'asc' }]);
  const [sortingAuditee, setSortingAuditee] = useState([{ columnName: 'AUDITEE_ID', direction: 'asc' }]);
  const [searchValue, setSearchValue] = useState('');
  const [defaultFilters] = useState([{ columnName: 'scope', value: 1 },]);

  const [filteringStateColumnExtensions] = useState([
    { columnName: 'scope', filteringEnabled: false },
    { columnName: 'action', filteringEnabled: false },
  ]);
  const [years, setYears] = useState('');
  const [audit, setAudit] = useState('');
  const [scope, setScopes] = useState('');
  const [auditee, setAuditee] = useState([]);
  const [listAudit, setListAudit] = useState([]);

  const getRowId = row => row.ANSWER_ACTION_ID;

  const fetchAuditee = async () => {
    const orderBy = sortingAuditee?.[0];
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}auditees`, {
      params: {
        expand: 'scope,department',
        page: currentPage + 1,
        'per-page': 50,
        'search': searchValue,
        sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
      }
    });

    if (response.status !== 200) throw new Error(`Fetch error`);
    setAuditee(response.data.items)

  }

  const onChangeScope = (e) => {
    let scp = e.target.value;
    setScopes(e.target.value);


    let listAuditee = []
    auditee.forEach(audit => {
      if(audit.SCOPE_ID==scp || scp==''){
        listAuditee.push(audit)
      }
    })
    setListAudit(listAuditee)
    console.log(listAuditee)

  }

  const fetchAnswerActions = async () => {

    setLoading(true);

    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          expand: [
            'answer.form.criteria',
            'pics.employee',
            'actionType',
            'actionType',
            'answer.form.schedule.instrument',
            'answer.form.schedule.auditee.department'
          ].join(','),
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          'year': years,
          'scope': scope,
          'auditee': audit,
          sort: `${orderBy?.direction === 'asc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const fetchListYear = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedule/list-year`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        }
      });
      setListYear(response.data.result)

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const [listYear, setListYear] = useState([]);

  useEffect(fetchAnswerActions, [searchValue, pageSize, currentPage, sorting]);
  useEffect(fetchAuditee, []);
  useEffect(fetchListYear, []);
  return (
    <>
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Agenda
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Monitoring
          </Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Finding List</Card.Title>
                <Card.Body>
                  <Row>
                    Additional Filtering
                  </Row>
                  <Row>
                    <Form.Group as={Col}>
                      <Form.Control className="w-100" name="YEAR_ID" as="select" onChange=
                        {e => {
                          setYears(e.target.value);
                        }}
                      >
                        <option>Select Years...</option>
                        {listYear && listYear.map((year, key) => (
                        <option key={key} value={year.VALUE?year.VALUE:''}>
                          {year.YEAR}
                        </option>
                        ))}
                        {/* <option value='2021'>2021</option>
                        <option value='2022'>2022</option>
                        <option value='2023'>2023</option>
                        <option value='2024'>2024</option>
                        <option value='2025'>2025</option>
                        <option value=''>All</option> */}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Control className="w-100" name="SCOPE_ID" as="select" onChange={onChangeScope}
                      >
                        <option>Select Scope...</option>
                        <option value='1'>Program Studi</option>
                        <option value='2'>Fakultas</option>
                        <option value='3'>Department</option>
                        <option value='5'>Univ</option>
                        <option value=''>All</option>
                      </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Control className="w-100" name="Auditee_id" as="select" onChange={e => {setAudit(e.target.value);}}
                      >
                        <option key='100' value='100'>Select Auditee...</option>
                        {listAudit.map(auditee =>
                          <option key={auditee.AUDITEE_ID} value={auditee.AUDITEE_ID}>{auditee.department.DEPT_NAME}</option>
                        )}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Button onClick={fetchAnswerActions}>Show</Button>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card.Header>
              <Card.Body>
                <Grid
                  rows={rows}
                  columns={columns}
                  getRowId={getRowId}
                >
                  <SearchState onValueChange={setSearchValue} />

                  <PagingState
                    currentPage={currentPage}
                    onCurrentPageChange={setCurrentPage}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                  />

                  <SortingState
                    sorting={sorting}
                    onSortingChange={setSorting}
                  />

                  <CustomPaging totalCount={totalCount} />
                  <Table />
                  <TableColumnResizing
                    columnWidths={columnWidths}
                    onColumnWidthsChange={setColumnWidths}
                  />
                  <TableHeaderRow showSortingControls />
                  <PagingPanel
                    pageSizes={pageSizes}
                  />
                  <Toolbar />
                  <SearchPanel />
                  {loading && <Loading />}
                </Grid>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}